export const statusFilterOptions = [
  {
    id: 'ONLINE',
    description: 'Online',
    value: true,
  },
  {
    id: 'OFFLINE',
    description: 'Offline',
    value: false,
  },
  {
    id: 'FAULTED',
    description: 'Falha',
    value: 'faulted',
  },
];
